export default [
    {
        path: '/billing',
        component : () => import('@/views/billing/main'),
        children:[
            {
                path:'/',
                component : () => import('@/views/billing/dashboard')
            },
            {
                path:'dashboard',
                component : () => import('@/views/billing/dashboard')
            },
            {
                path:'electricity',
                component : () => import('@/views/billing/electricity/electricity.bill')
            },
            {
                path:'customer',
                component : () => import('@/views/billing/customer/customer.main')
            },
            {
                path:'contract',
                component : () => import('@/views/billing/contract/contract.main')
            },
            {
                path:'contract/task',
                component : () => import('@/views/billing/contract/contract.task.main')
            },
            {
                path:'contract/item/record',
                component : () => import('@/views/billing/contract/item/record/contract.item.record.main')
            },
            {
                path:'contract/bill/adjust',
                component : () => import('@/views/billing/contract/bill/contract.bill.adjust.main')
            },
            {
                path:'contract/bill/customer',
                component : () => import('@/views/billing/contract/bill/customer/bill.customer.main'),
                children: [
                    {
                        name: 'billcustomerlist',
                        path: 'billcustomerlist',
                        component: () => import('@/views/billing/contract/bill/customer/bill.customer.list')
                    },
                    {
                        name: 'billcustomerdetail',
                        path: 'billcustomerdetail',
                        component: () => import('@/views/billing/contract/bill/customer/bill.customer.detail')
                    },
                ],
                redirect: 'contract/bill/customer/billcustomerlist'
            },
            {
                name:'billcustomergeneratorlist',
                path:'contract/bill/customer/generator',
                component : () => import('@/views/billing/contract/bill/customer/bill.customer.generator.list')
            },
            {
                path:'contract/bill/month',
                component : () => import('@/views/billing/contract/bill/month/contract.bill.month.main')
            },
            {
                path:'contract/record',
                component : () => import('@/views/billing/contract/record/contract-record-main')
            },
        ]
    },
];
